import React from 'react';
import { MapMarkerCheckSolid } from 'emerald-icons/dist/MapMarkerCheckSolid';
import { gray6 } from '../globals/colors';
import styled from 'styled-components';
import { Token } from './Token.style';

export var GenericToken = styled(Token).attrs(function () {return {
    children: /*#__PURE__*/React.createElement(MapMarkerCheckSolid, null)
  };}).withConfig({ displayName: "GenericToken", componentId: "sc-musa2g-0" })(["background:", ";"],
gray6);
//# sourceMappingURL=GenericToken.js.map